import style from "./style.module.scss";
import SeoHelmet from "../seo-helmet";
import HeroSection from "./hero-section";
import ProcessSection from "./process-section";
import FeaturesSection from "./features-section";
import PricingSection from "./pricing-section";
import TestimonialsSection from "./testimonials-section";
import CtaSection from "./cta-section";
import Footer from "../footer";
import type { ComponentType } from "react";

interface SeoConfig {
  title: string;
  description: string;
  canonicalUrl?: string;
  ogImage?: string;
  structuredData?: Record<string, unknown>;
}

interface CtaConfig {
  label: string;
  to: string;
  icon?: ComponentType;
}

interface HeroConfig {
  headline: string;
  tagline: string;
  ctas: CtaConfig[];
  backgroundImage: string;
}

interface FeatureConfig {
  icon?: ComponentType;
  title: string;
  description: string;
}

interface PricingConfig {
  price: number;
  priceLabel?: string;
  currency: string;
  includes?: string[];
  ctaLabel: string;
  ctaTo: string;
}

interface LandingProps {
  seo: SeoConfig;
  hero: HeroConfig;
  features: FeatureConfig[];
  pricing?: PricingConfig;
}

function Landing({ seo, hero, features, pricing }: LandingProps) {
  return (
    <div className={style.landing}>
      <SeoHelmet
        title={seo.title}
        description={seo.description}
        canonicalUrl={seo.canonicalUrl}
        ogImage={seo.ogImage}
        structuredData={seo.structuredData}
      />

      <HeroSection
        headline={hero.headline}
        tagline={hero.tagline}
        ctas={hero.ctas}
        backgroundImage={hero.backgroundImage}
      />

      <ProcessSection />

      <FeaturesSection features={features} />

      <TestimonialsSection />

      {pricing && (
        <PricingSection
          price={pricing.price}
          priceLabel={pricing.priceLabel}
          currency={pricing.currency}
          includes={pricing.includes}
          ctaLabel={pricing.ctaLabel}
          ctaTo={pricing.ctaTo}
        />
      )}

      <CtaSection
        label={hero.ctas[0]?.label || "Commencer"}
        to={hero.ctas[0]?.to || "/start/photo-book"}
      />

      <Footer className={style.footer} />
    </div>
  );
}

export default Landing;
